import { Col, Row} from 'reactstrap';
import LabelField from '../../../components/LabelField';
import { checkNullValue, convertDate, convertWithoutTimezone, formattedDate, getProductData, roundUpToTwoDecimals } from '../../../utils/Util';
import { POLICY_TYPE_ID } from '../../../utils/Constant';
import {useSelector } from 'react-redux';
import { mapMasters } from '../../../utils/MastersMapping';

const AdditionalInfo = ({data, reopenDate, tat} : any) => {
    const {
        storeGrievanceDescriptionData,
        storeProductData
    }= useSelector((state: any) => state.grievances);
    const grievanceDescriptions = storeGrievanceDescriptionData?.data ?? [];
    
    const productData = getProductData(
      storeProductData.data ?? []
    );
    
    return (
        <>
          <Row style={{ borderBottom: '1px solid #D0DAE7', marginBottom: '3%' }} >
            <Col xs={6} md={4}>
              <LabelField name='Caller Mobile Number'></LabelField>
              <p style={{ color: '#00000080' }} className='grievance-details'>{checkNullValue(data?.callerMobileNo)}</p>
            </Col>

            <Col xs={6} md={4}>
              <LabelField name='Insurance Company'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.insuranceCompany)}
                </p>
            </Col>

            <Col xs={6} md={4}>
                <LabelField name='Sub Category'></LabelField>
                <p className='grievance-details'>{checkNullValue(data?.subCategory)}</p>
            </Col>

            <Col xs={6} md={4}>
                <LabelField name='Internal Reference Id'></LabelField>
                <p className='grievance-details'>{checkNullValue(data?.additionalInfo?.internalReferenceId)}</p>
            </Col>

            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Turn Around Time'></LabelField>
              <p className='grievance-details'>{checkNullValue(tat)}</p>
            </Col>
          </Row>

          <Row>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Season'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.season ?? data?.additionalInfo?.season )}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Year'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.year ?? data?.additionalInfo?.quotationDate)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Crop Name'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.cropName ?? data?.additionalInfo?.crop)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Product'></LabelField>
              <p className='grievance-details'>{checkNullValue(mapMasters(data?.product, productData))}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Relation'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.relation)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Relative Name'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.relativeName)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Policy Premium'></LabelField>
              <p className='grievance-details'>{roundUpToTwoDecimals(data?.policyPremium ?? data?.additionalInfo?.premium)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Policy Area'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.policyArea)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Policy Type'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.policyType)==="N/A"  ? (data?.additionalInfo?.Policy_Type_Id==POLICY_TYPE_ID ? "Crop": "N/A") : data?.policyType}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Land Survey Number'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.landSurveyNo ?? data?.additionalInfo?.surveynumber)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Land Division Number'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.landDivisionNo ?? data?.additionalInfo?.subsurveynumber)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Plot State'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.plotState)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Plot District'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.plotDistrict)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Plot Village'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.plotVillage)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Application Source'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.applicationSource)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Crop Share'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.cropShare)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='IFSC Code'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.ifscCode)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Farmer Share'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.farmerShare)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Sowing Date'></LabelField>
              <p className='grievance-details'>{formattedDate(data?.sowingDate)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Crop Lost at'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.cropLossAt)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Resolved Date'></LabelField>
              <p className='grievance-details'>{data?.resolutionDate ? convertDate(convertWithoutTimezone(data?.resolutionDate)) : 'N/A' }</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Reopened Date'></LabelField>
              <p className='grievance-details'>{checkNullValue(reopenDate)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Proposal Number'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.additionalInfo?.Proposal_Or_Cover_Note_Number)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Certificate Number'></LabelField>
              <p className='grievance-details'>{checkNullValue(data?.additionalInfo?.Certificate_Number)}</p>
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name='Complaint Description'></LabelField>
              <p className='grievance-details'>{checkNullValue(
                grievanceDescriptions.find((each: any) => each.id === data?.complaintDescriptionId)?.value
              )}</p>
            </Col>
            {(data?.grievanceModeBean.grievanceModeId === 1 || data?.grievanceModeBean.grievanceModeId === 4 || data?.grievanceModeBean.grievanceModeId === 3) && (//KRPH
              <Col xs={6} md={4} className="mb-3">
                <LabelField name='Support Ticket Number'></LabelField>
                <p className='grievance-details'>{checkNullValue(JSON.parse(data?.additionalInfo?.ticket ?? '{}')?.SupportTicketNo)}</p>
              </Col>
            )}
          </Row>
        </>
    );
}

export default AdditionalInfo;